import { useEffect } from 'react';

import { useInView } from 'react-intersection-observer';

import isFunction from 'lodash/fp/isFunction';

import { legacyTheme, styled } from '@prose-ui/legacy';

import { breakpoints } from 'Components/ThemeProvider';

import ConsultationCTA from 'Containers/ConsultationCTA';
import ScrollTracker from 'Containers/ScrollTracker';

import useMedia from 'utils/useMedia';

import FAQBlock from '../SharedComponents/FAQBlock';
import MembershipTicker from '../SharedComponents/MembershipTicker';
import JourneyBlock from './JourneyBlock';
import LegalsBlock from './LegalsBlock';
import ProspectHero from './ProspectHero';
import ProspectPercs from './ProspectPercs';

const ProspectLandingPageWrapper = styled('div')({
  width: '100%',
  [legacyTheme.breakpoints.match('sm')]: {
    paddingBottom: 50,
  },
});

const ProspectLandingPage = () => {
  useEffect(() => {
    if (isFunction(window.hj)) {
      window.hj('trigger', `membership_prospect`);
    }
  }, [window.hj]);
  const isMobile = useMedia(`(max-width: ${breakpoints.sm - 1}px)`);
  const [heroRef, heroInView] = useInView({ threshold: 0.2 });
  return (
    <ProspectLandingPageWrapper data-testid="membership-prospect-page">
      <ScrollTracker>
        <ProspectHero ref={heroRef} />
        <MembershipTicker content={['your hair looks god today btw!']} />
        <ProspectPercs />
        <JourneyBlock />
        <FAQBlock />
        <LegalsBlock />
        {isMobile && !heroInView && (
          <ConsultationCTA dataFrom="sticky-footer" fixed label="Begin your journey" theme="lime" />
        )}
      </ScrollTracker>
    </ProspectLandingPageWrapper>
  );
};

ProspectLandingPage.propTypes = {};

ProspectLandingPage.defaultProps = {};

export default ProspectLandingPage;
